unit ImportDataEdit;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.DBCtrls, Data.DB, WEBLib.DB, Vcl.Mask, WEBLib.Mask, WebForm.Core,
  WEBLib.DropDown, WEBLib.Country, WEBLib.ExtCtrls, WEBLib.Actions,
  WEBLib.WebCtrls, SMX.Web.Document.Utils;

type
  TImportDataEditForm = class(TCoreWebForm)
    FormCaption: TLabel;
    MessageLabel: TLabel;
    CancelButton: TButton;
    SaveButton: TButton;
    DataState: THTMLSpan;
    PriorButton: TButton;
    NextButton: TButton;
    EditDataSource: TDataSource;
    EditElements: TElementActionList;
    CloseTimer: TTimer;
    DonorIdLabel: TDBLabel;
    ExternalIdLabel: TDBLabel;
    edFirstName: TDBEdit;
    edLastName: TDBEdit;
    edAdd1: TDBEdit;
    edAdd2: TDBEdit;
    edAdd3: TDBEdit;
    edCity: TDBEdit;
    edPostCode: TDBEdit;
    edEmail: TDBEdit;
    edMobile: TDBEdit;
    edTelephone: TDBEdit;
    DateSigned: TDBDateTimePicker;
    ContactByPhone: TDBCheckBox;
    ContactByEmail: TDBCheckBox;
    ContactByText: TDBCheckBox;
    ContactByPost: TDBCheckBox;
    TitleEdit: TDBEdit;
    DataEditAmount: TDBEdit;
    CloseButton: TButton;
    edCounty: TDBEdit;
    ExternalIdEdit: TDBEdit;
    MessageDialog: TMessageDlg;
    ErrorMessagePostCode: TLabel;
    ErrorMessageDateSigned: TLabel;
    ErrorMessageAmount: TLabel;
    CountryList: TCountryComboBox;
    procedure CancelButtonClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure CloseButtonClick(Sender: TObject);
    procedure ContactByClick(Sender: TObject);
    procedure CountryListExit(Sender: TObject);
    procedure DataEditAmountChange(Sender: TObject);
    procedure DataEditAmountExit(Sender: TObject);
    procedure DataEditAmountKeyPress(Sender: TObject; var Key: Char);
    procedure DateSignedExit(Sender: TObject);
    procedure edAdd1Exit(Sender: TObject);
    procedure edFirstNameExit(Sender: TObject);
    procedure EditDataSourceDataChange(Sender: TObject; Field: TField);
    procedure edLastNameExit(Sender: TObject);
    procedure SaveButtonClick(Sender: TObject);
    procedure edPostCodeChange(Sender: TObject);
  private
    { Private declarations }
    fEditDataApplyUpdates: boolean;
    FModified: boolean;
    FStoreCountryCode: string;
    FErrorList: string;
    FDateSigned: boolean;
    FPostCodeValid: boolean;

    procedure SetDataSet(Value: TDataSet);
    procedure ResetButtons(Value: boolean);
    procedure SetCountryDropDown;
    procedure SaveData;
    procedure SetErrorList(AErrorList: string);
    procedure DateSignedCheck(ADate: string);
    procedure Validate;
    procedure PostCodeChange;
  public
    { Public declarations }
    property DataSet: TDataSet write SetDataSet;
    property EditDataApplyUpdates: boolean read fEditDataApplyUpdates;
    property ErrorList: string read fErrorList write SetErrorList;
  protected procedure LoadDFMValues; override; end;

var
  ImportDataEditForm: TImportDataEditForm;

implementation

{$R *.dfm}

uses
   ImportData, GA.Web.Utils, SMX.CRM.Utils;

procedure TImportDataEditForm.CancelButtonClick(Sender: TObject);
begin
  EditDataSource.DataSet.Cancel;
  ResetButtons(False);
end;

   { TImportDataEditForm }

procedure TImportDataEditForm.WebFormCreate(Sender: TObject);
begin
  inherited;
  fEditDataApplyUpdates := false;
end;

procedure TImportDataEditForm.CloseButtonClick(Sender: TObject);
begin
  ModalResult := mrOK;
end;

procedure TImportDataEditForm.ContactByClick(Sender: TObject);
begin
  FModified := true;
end;

procedure TImportDataEditForm.CountryListExit(Sender: TObject);
begin
  if CountryList.Text = '' then
    TDocUtils.setControlValidity('CountryList', vsInvalid)
  else
    TDocUtils.setControlValidity('CountryList', vsValid);

  PostCodeChange;
  Validate;
end;

procedure TImportDataEditForm.DataEditAmountChange(Sender: TObject);
var
  lAmount: double;
begin
  if DataEditAmount.Text <> '' then
  begin
    lAmount := strtofloat(DataEditAmount.text);
    if lAmount > 0.00 then
      TDocUtils.setControlValidity('DataEditAmount', vsValid)
    else
      TDocUtils.setControlValidity('DataEditAmount', vsInvalid);
  end
  else
    TDocUtils.setControlValidity('DataEditAmount', vsInvalid);
  Validate;
end;

procedure TImportDataEditForm.DataEditAmountExit(Sender: TObject);
var
  lAmount: double;
begin
  if DataEditAmount.Text <> '' then
  begin
    lAmount := strtofloat(DataEditAmount.text);
    if lAmount > 0.00 then
      TDocUtils.setControlValidity('DataEditAmount', vsValid)
    else
      TDocUtils.setControlValidity('DataEditAmount', vsInvalid);
  end
  else
    TDocUtils.setControlValidity('DataEditAmount', vsInvalid);
  Validate;
end;

procedure TImportDataEditForm.DataEditAmountKeyPress(Sender: TObject; var Key:
    Char);
begin
  if (not (Key in ['0'..'9','.'])) or ((Key = '.') and (Pos('.', DataEditAmount.text) > 0)) then
  begin
    Key := #0;
  end
end;

procedure TImportDataEditForm.DateSignedExit(Sender: TObject);
var
  EarliestDateStr: string;
  EarliestDate: TDateTime;
begin
//  inherited;
  FDateSigned := True;

  if DateSigned.DateTime = 0 then
  begin
    ErrorMessageDateSigned.Caption := 'Donation Date cannot be blank';
    TDocUtils.setControlValidity('DateSigned', vsInvalid);
    FDateSigned := False;
  end
  else if DateSigned.Date > Date then
  begin
    ErrorMessageDateSigned.Caption := 'Donation Date in the future';
    TDocUtils.setControlValidity('DateSigned', vsInvalid);
    FDateSigned := False;
  end
  else
  begin
    EarliestDate := TGAWebUtils.EarliestClaimableDate(Now);

    if EarliestDate > DateSigned.Date then
    begin
      ErrorMessageDateSigned.Caption := 'Donation Date can not be before ' + FormatDateTime('DD/MM/YYYY', EarliestDate);
      TDocUtils.setControlValidity('DateSigned', vsInvalid);
      FDateSigned := False;
    end;
  end;

  if FDateSigned then
    TDocUtils.setControlValidity('DateSigned', vsValid);
  Validate;
end;

procedure TImportDataEditForm.EditDataSourceDataChange(Sender: TObject; Field:
    TField);
begin
//  if Field <> nil then
//  begin
//    ResetButtons(EditDataSource.DataSet.Modified);
//  end;
end;

procedure TImportDataEditForm.SaveButtonClick(Sender: TObject);
begin
  SaveData;
  ModalResult := mrOK;
end;

procedure TImportDataEditForm.SetDataSet(Value: TDataSet);
begin
  EditDataSource.DataSet := Value;
  SetCountryDropDown;
end;

procedure TImportDataEditForm.ResetButtons(Value: boolean);
begin
  SaveButton.Enabled := Value;
  CancelButton.Enabled := Value;
  FModified := Value;
end;


procedure TImportDataEditForm.SetCountryDropDown;
var
  lCountryCode: string;
  lCountry: string;
begin
  if EditDataSource.DataSet.FieldByName('CountryCode').AsString <> '' then
  begin
    lCountryCode := EditDataSource.DataSet.FieldByName('CountryCode').AsString;

    if lCountryCode <> '' then
    begin
      lCountry := GetCountryByCode(lCountryCode);
      CountryList.Text := lCountry;
      FStoreCountryCode := lCountryCode;
    end;
  end;
end;

procedure TImportDataEditForm.SaveData;
var
  lTitle: string;
  lCountry: string;
  lCountryCode: string;
  lCurrentCountryCode: string;
begin
  lCountry := CountryList.Text;

  if CountryList.Text <> '' then
  begin
    lCountryCode := GetCountryCode(lCountry);

    if (FStoreCountryCode <> lCountryCode) then
    begin
      EditDataSource.Edit;
      EditDataSource.Dataset.FieldByName('CountryCode').AsString := lCountryCode;
      FModified := true;
    end;
  end;

  if (EditDataSource.DataSet.State in dsEditModes) and ((EditDataSource.DataSet.Modified) or (FModified)) then
  begin
    EditDataSource.Dataset.FieldByName('ContactByPhone').AsBoolean := ContactByPhone.Checked;
    EditDataSource.Dataset.FieldByName('ContactByPost').AsBoolean := ContactByPost.Checked;
    EditDataSource.Dataset.FieldByName('ContactByText').AsBoolean := ContactByText.Checked;
    EditDataSource.Dataset.FieldByName('ContactByEmail').AsBoolean := ContactByEmail.Checked;

    EditDataSource.DataSet.Post;
    fEditDataApplyUpdates := true;
    ResetButtons(False);
  end;
end;


procedure TImportDataEditForm.SetErrorList(AErrorList: string);
var
  lEarliestDate: TDate;
  lEarliestDateStr: string;
  lCountryCode: string;
begin
  lCountryCode := EditDataSource.DataSet.FieldByName('CountryCode').AsString;
  FErrorList := AErrorList;
  FDateSigned := True;
  FPostCodeValid := True;


  if edFirstName.text = '' then
    TDocUtils.setControlValidity('FirstName', vsInvalid)
  else
    TDocUtils.setControlValidity('FirstName', vsValid);

  if edLastName.text = '' then
    TDocUtils.setControlValidity('LastName', vsInvalid)
  else
    TDocUtils.setControlValidity('LastName', vsValid);

  if Pos('Donation', FErrorList) > 0 then
  begin
    if Pos('OutOfRange', FErrorList) > 0 then
    begin
      lEarliestDateStr := TGAWebUtils.EarliestClaimableDateStr(Now);
      ErrorMessageDateSigned.Caption := 'Donation Date can not be before ' + lEarliestDateStr;
    end
    else
    begin
      if Pos('Future', FErrorList) > 0 then
      begin
        ErrorMessageDateSigned.Caption := 'Donation Date in the future';
      end
    end;
    TDocUtils.setControlValidity('DateSigned', vsInvalid);
    FDateSigned := False;
  end
  else
  begin
    TDocUtils.setControlValidity('DateSigned', vsValid);
  end;

  if Pos('Address', FErrorList) > 0 then
    TDocUtils.setControlValidity('Add1', vsInvalid)
  else
    TDocUtils.setControlValidity('Add1', vsValid);


  if lCountryCode = 'GB' then
  begin
  if Pos('Postcode', FErrorList) > 0 then
  begin
    if Pos('Format', FErrorList) > 0 then
    begin
      TDocUtils.setControlValidity('PostCode', vsInvalid);
      ErrorMessagePostCode.Caption := 'Invalid Post Code';
    end
    else
    begin
      TDocUtils.setControlValidity('PostCode', vsInvalid);
      ErrorMessagePostCode.Caption := 'Blank Post Code';
    end;
    TDocUtils.setControlValidity('PostCode', vsInvalid);
    FPostCodeValid := False;
  end
  else
  begin
    TDocUtils.setControlValidity('PostCode', vsValid);
  end;
  end
  else
  begin
    if Pos('', FErrorList) > 0 then
    begin
      TDocUtils.setControlValidity('PostCode', vsInvalid);
      ErrorMessagePostCode.Caption := 'Error';
    end;
  end;

  if Pos('Amount', FErrorList) > 0 then
  begin
    if Pos('£0.00', FErrorList) > 0 then
    begin
      ErrorMessageAmount.Caption := 'Amount can not be zero';
    end;
    TDocUtils.setControlValidity('DataEditAmount', vsInvalid);
  end;

  if CountryList.Text = '' then
    TDocUtils.setControlValidity('CountryList', vsInvalid)
  else
    TDocUtils.setControlValidity('CountryList', vsValid);
  Validate;
end;

procedure TImportDataEditForm.DateSignedCheck(ADate: string);
begin
end;

procedure TImportDataEditForm.edAdd1Exit(Sender: TObject);
begin
  if edAdd1.Text = '' then
    TDocUtils.setControlValidity('Add1', vsInvalid)
  else
    TDocUtils.setControlValidity('Add1', vsValid);
  Validate;
end;

procedure TImportDataEditForm.edFirstNameExit(Sender: TObject);
begin
  if edFirstName.Text = '' then
    TDocUtils.setControlValidity('FirstName', vsInvalid)
  else
    TDocUtils.setControlValidity('FirstName', vsValid);
  Validate;
end;

procedure TImportDataEditForm.edLastNameExit(Sender: TObject);
begin
  if edLastName.Text = '' then
    TDocUtils.setControlValidity('LastName', vsInvalid)
  else
    TDocUtils.setControlValidity('LastName', vsValid);
  Validate;
end;

procedure TImportDataEditForm.edPostCodeChange(Sender: TObject);
begin
  //inherited;
  PostCodeChange;
end;

procedure TImportDataEditForm.Validate;
var
  ValidDonation: boolean;
begin
  ValidDonation := True;

  if edFirstName.text = '' then
    ValidDonation := False;

  if edLastName.text = '' then
    ValidDonation := False;

  if edAdd1.text = '' then
    ValidDonation := False;

  if (DataEditAmount.text = '0') or (DataEditAmount.text = '') then
    ValidDonation := False;

  if CountryList.Text = '' then
    ValidDonation := False;

  if FPostCodeValid = False then
    ValidDonation := False;

  if FDateSigned = False then
    ValidDonation := False;

  SaveButton.Enabled := ValidDonation;
end;

procedure TImportDataEditForm.PostCodeChange;
var
  lCountry: string;

begin
  lCountry := CountryList.Text;

  if Pos('United Kingdom', lCountry) > 0 then
  begin
    if Length(edPostCode.text) > 4 then
    begin
      edPostCode.Text := TCRMUtils.FormatPostCode(edPostCode.Text);
      if TCRMUtils.IsPostCode(edPostCode.Text) <> pcFull then
      begin
        TDocUtils.setControlValidity('PostCode', vsInvalid);
        FPostCodeValid := False;
      end
      else
      begin
        TDocUtils.setControlValidity('PostCode', vsValid);
        FPostCodeValid := True;
      end;
    end
    else if Length(edPostCode.Text) > 0 then
    begin
      TDocUtils.setControlValidity('PostCode', vsNone);
      FPostCodeValid := False;
    end
    else
      TDocUtils.setControlValidity('PostCode', vsInValid);
  end
  else
  begin
    if edPostCode.Text = '' then
    begin
      TDocUtils.setControlValidity('PostCode', vsInvalid);
      FPostCodeValid := False;
    end
    else
    begin
      TDocUtils.setControlValidity('PostCode', vsValid);
      FPostCodeValid := True;
    end;
  end;

  Validate;
end;

procedure TImportDataEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  FormCaption := TLabel.Create('FormCaption');
  MessageLabel := TLabel.Create('MessageLabel');
  DonorIdLabel := TDBLabel.Create('DonorIdLabel');
  ExternalIdLabel := TDBLabel.Create('ExternalIdLabel');
  ErrorMessagePostCode := TLabel.Create('ErrorMessagePostCode');
  ErrorMessageDateSigned := TLabel.Create('ErrorMessageDateSigned');
  ErrorMessageAmount := TLabel.Create('ErrorMessageAmount');
  CancelButton := TButton.Create('CancelButton');
  SaveButton := TButton.Create('SaveButton');
  DataState := THTMLSpan.Create('DataState');
  PriorButton := TButton.Create('PriorButton');
  NextButton := TButton.Create('NextButton');
  edFirstName := TDBEdit.Create('FirstName');
  edLastName := TDBEdit.Create('LastName');
  edAdd1 := TDBEdit.Create('Add1');
  edAdd2 := TDBEdit.Create('Add2');
  edAdd3 := TDBEdit.Create('Add3');
  edCity := TDBEdit.Create('City');
  edPostCode := TDBEdit.Create('PostCode');
  edEmail := TDBEdit.Create('Email');
  edMobile := TDBEdit.Create('Mobile');
  edTelephone := TDBEdit.Create('Phone');
  DateSigned := TDBDateTimePicker.Create('DateSigned');
  ContactByPhone := TDBCheckBox.Create('ContactByPhone');
  ContactByEmail := TDBCheckBox.Create('ContactByEmail');
  ContactByText := TDBCheckBox.Create('ContactByText');
  ContactByPost := TDBCheckBox.Create('ContactByPost');
  TitleEdit := TDBEdit.Create('Title');
  DataEditAmount := TDBEdit.Create('DataEditAmount');
  CloseButton := TButton.Create('DonorCloseButton');
  edCounty := TDBEdit.Create('CountyEdit');
  ExternalIdEdit := TDBEdit.Create('ExternalIdEdit');
  MessageDialog := TMessageDlg.Create(Self);
  CountryList := TCountryComboBox.Create('CountryList');
  EditDataSource := TDataSource.Create(Self);
  EditElements := TElementActionList.Create(Self);
  CloseTimer := TTimer.Create(Self);

  FormCaption.BeforeLoadDFMValues;
  MessageLabel.BeforeLoadDFMValues;
  DonorIdLabel.BeforeLoadDFMValues;
  ExternalIdLabel.BeforeLoadDFMValues;
  ErrorMessagePostCode.BeforeLoadDFMValues;
  ErrorMessageDateSigned.BeforeLoadDFMValues;
  ErrorMessageAmount.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  SaveButton.BeforeLoadDFMValues;
  DataState.BeforeLoadDFMValues;
  PriorButton.BeforeLoadDFMValues;
  NextButton.BeforeLoadDFMValues;
  edFirstName.BeforeLoadDFMValues;
  edLastName.BeforeLoadDFMValues;
  edAdd1.BeforeLoadDFMValues;
  edAdd2.BeforeLoadDFMValues;
  edAdd3.BeforeLoadDFMValues;
  edCity.BeforeLoadDFMValues;
  edPostCode.BeforeLoadDFMValues;
  edEmail.BeforeLoadDFMValues;
  edMobile.BeforeLoadDFMValues;
  edTelephone.BeforeLoadDFMValues;
  DateSigned.BeforeLoadDFMValues;
  ContactByPhone.BeforeLoadDFMValues;
  ContactByEmail.BeforeLoadDFMValues;
  ContactByText.BeforeLoadDFMValues;
  ContactByPost.BeforeLoadDFMValues;
  TitleEdit.BeforeLoadDFMValues;
  DataEditAmount.BeforeLoadDFMValues;
  CloseButton.BeforeLoadDFMValues;
  edCounty.BeforeLoadDFMValues;
  ExternalIdEdit.BeforeLoadDFMValues;
  MessageDialog.BeforeLoadDFMValues;
  CountryList.BeforeLoadDFMValues;
  EditDataSource.BeforeLoadDFMValues;
  EditElements.BeforeLoadDFMValues;
  CloseTimer.BeforeLoadDFMValues;
  try
    Width := 969;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    FormCaption.SetParentComponent(Self);
    FormCaption.Name := 'FormCaption';
    FormCaption.Left := 72;
    FormCaption.Top := 12;
    FormCaption.Width := 86;
    FormCaption.Height := 25;
    FormCaption.Margins.Left := 5;
    FormCaption.Margins.Top := 5;
    FormCaption.Margins.Right := 5;
    FormCaption.Margins.Bottom := 5;
    FormCaption.Caption := 'Edit Donor';
    FormCaption.ElementClassName := 'HeadlineClass';
    FormCaption.ElementFont := efCSS;
    FormCaption.ElementPosition := epIgnore;
    FormCaption.HeightStyle := ssAuto;
    FormCaption.HeightPercent := 100.000000000000000000;
    FormCaption.HTMLType := tDIV;
    FormCaption.WidthStyle := ssAuto;
    FormCaption.WidthPercent := 100.000000000000000000;
    MessageLabel.SetParentComponent(Self);
    MessageLabel.Name := 'MessageLabel';
    MessageLabel.Left := 68;
    MessageLabel.Top := 41;
    MessageLabel.Width := 111;
    MessageLabel.Height := 25;
    MessageLabel.Margins.Left := 5;
    MessageLabel.Margins.Top := 5;
    MessageLabel.Margins.Right := 5;
    MessageLabel.Margins.Bottom := 5;
    MessageLabel.Caption := 'MessageLabel';
    MessageLabel.ElementFont := efCSS;
    MessageLabel.ElementPosition := epIgnore;
    MessageLabel.HeightStyle := ssAuto;
    MessageLabel.HeightPercent := 100.000000000000000000;
    MessageLabel.HTMLType := tDIV;
    MessageLabel.WidthStyle := ssAuto;
    MessageLabel.WidthPercent := 100.000000000000000000;
    DonorIdLabel.SetParentComponent(Self);
    DonorIdLabel.Name := 'DonorIdLabel';
    DonorIdLabel.Left := 232;
    DonorIdLabel.Top := 27;
    DonorIdLabel.Width := 108;
    DonorIdLabel.Height := 25;
    DonorIdLabel.Caption := 'DonorIdLabel';
    DonorIdLabel.ElementFont := efCSS;
    DonorIdLabel.HeightStyle := ssAuto;
    DonorIdLabel.HeightPercent := 100.000000000000000000;
    DonorIdLabel.WidthPercent := 100.000000000000000000;
    DonorIdLabel.DataField := 'Id';
    DonorIdLabel.DataSource := EditDataSource;
    ExternalIdLabel.SetParentComponent(Self);
    ExternalIdLabel.Name := 'ExternalIdLabel';
    ExternalIdLabel.Left := 232;
    ExternalIdLabel.Top := 46;
    ExternalIdLabel.Width := 118;
    ExternalIdLabel.Height := 25;
    ExternalIdLabel.Caption := 'ExternalIdLabel';
    ExternalIdLabel.ElementFont := efCSS;
    ExternalIdLabel.HeightStyle := ssAuto;
    ExternalIdLabel.HeightPercent := 100.000000000000000000;
    ExternalIdLabel.WidthStyle := ssAuto;
    ExternalIdLabel.WidthPercent := 100.000000000000000000;
    ExternalIdLabel.DataField := 'ExternalId';
    ExternalIdLabel.DataSource := EditDataSource;
    ErrorMessagePostCode.SetParentComponent(Self);
    ErrorMessagePostCode.Name := 'ErrorMessagePostCode';
    ErrorMessagePostCode.Left := 778;
    ErrorMessagePostCode.Top := 421;
    ErrorMessagePostCode.Width := 124;
    ErrorMessagePostCode.Height := 25;
    ErrorMessagePostCode.Caption := 'Post Code Error';
    ErrorMessagePostCode.HeightPercent := 100.000000000000000000;
    ErrorMessagePostCode.WidthPercent := 100.000000000000000000;
    ErrorMessageDateSigned.SetParentComponent(Self);
    ErrorMessageDateSigned.Name := 'ErrorMessageDateSigned';
    ErrorMessageDateSigned.Left := 776;
    ErrorMessageDateSigned.Top := 440;
    ErrorMessageDateSigned.Width := 200;
    ErrorMessageDateSigned.Height := 25;
    ErrorMessageDateSigned.Caption := 'ErrorMessageDateSigned';
    ErrorMessageDateSigned.HeightPercent := 100.000000000000000000;
    ErrorMessageDateSigned.WidthPercent := 100.000000000000000000;
    ErrorMessageAmount.SetParentComponent(Self);
    ErrorMessageAmount.Name := 'ErrorMessageAmount';
    ErrorMessageAmount.Left := 776;
    ErrorMessageAmount.Top := 400;
    ErrorMessageAmount.Width := 65;
    ErrorMessageAmount.Height := 25;
    ErrorMessageAmount.Caption := 'Amount';
    ErrorMessageAmount.HeightPercent := 100.000000000000000000;
    ErrorMessageAmount.WidthPercent := 100.000000000000000000;
    CancelButton.SetParentComponent(Self);
    CancelButton.Name := 'CancelButton';
    CancelButton.Left := 192;
    CancelButton.Top := 404;
    CancelButton.Width := 144;
    CancelButton.Height := 38;
    CancelButton.Margins.Left := 5;
    CancelButton.Margins.Top := 5;
    CancelButton.Margins.Right := 5;
    CancelButton.Margins.Bottom := 5;
    CancelButton.Caption := 'Cancel';
    CancelButton.ChildOrder := 3;
    CancelButton.ElementClassName := 'btn btn-primary';
    CancelButton.ElementFont := efCSS;
    CancelButton.ElementPosition := epIgnore;
    CancelButton.HeightStyle := ssAuto;
    CancelButton.HeightPercent := 100.000000000000000000;
    CancelButton.TabOrder := 22;
    CancelButton.WidthStyle := ssAuto;
    CancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelButton, Self, 'OnClick', 'CancelButtonClick');
    SaveButton.SetParentComponent(Self);
    SaveButton.Name := 'SaveButton';
    SaveButton.Left := 24;
    SaveButton.Top := 404;
    SaveButton.Width := 144;
    SaveButton.Height := 38;
    SaveButton.Margins.Left := 5;
    SaveButton.Margins.Top := 5;
    SaveButton.Margins.Right := 5;
    SaveButton.Margins.Bottom := 5;
    SaveButton.Caption := 'Save';
    SaveButton.ChildOrder := 2;
    SaveButton.ElementClassName := 'btn btn-secondary';
    SaveButton.ElementFont := efCSS;
    SaveButton.ElementPosition := epIgnore;
    SaveButton.HeightStyle := ssAuto;
    SaveButton.HeightPercent := 100.000000000000000000;
    SaveButton.TabOrder := 21;
    SaveButton.WidthStyle := ssAuto;
    SaveButton.WidthPercent := 100.000000000000000000;
    SetEvent(SaveButton, Self, 'OnClick', 'SaveButtonClick');
    DataState.SetParentComponent(Self);
    DataState.Name := 'DataState';
    DataState.Left := 10;
    DataState.Top := 66;
    DataState.Width := 150;
    DataState.Height := 38;
    DataState.Margins.Left := 5;
    DataState.Margins.Top := 5;
    DataState.Margins.Right := 5;
    DataState.Margins.Bottom := 5;
    DataState.HeightStyle := ssAuto;
    DataState.WidthStyle := ssAuto;
    DataState.ChildOrder := 5;
    DataState.ElementPosition := epIgnore;
    DataState.ElementFont := efCSS;
    DataState.Role := '';
    PriorButton.SetParentComponent(Self);
    PriorButton.Name := 'PriorButton';
    PriorButton.Left := 228;
    PriorButton.Top := 69;
    PriorButton.Width := 50;
    PriorButton.Height := 38;
    PriorButton.Margins.Left := 5;
    PriorButton.Margins.Top := 5;
    PriorButton.Margins.Right := 5;
    PriorButton.Margins.Bottom := 5;
    PriorButton.Caption := '<';
    PriorButton.ChildOrder := 6;
    PriorButton.ElementClassName := 'btn btn-info';
    PriorButton.ElementFont := efCSS;
    PriorButton.ElementPosition := epIgnore;
    PriorButton.HeightStyle := ssAuto;
    PriorButton.HeightPercent := 100.000000000000000000;
    PriorButton.Visible := False;
    PriorButton.WidthStyle := ssAuto;
    PriorButton.WidthPercent := 100.000000000000000000;
    NextButton.SetParentComponent(Self);
    NextButton.Name := 'NextButton';
    NextButton.Left := 287;
    NextButton.Top := 69;
    NextButton.Width := 49;
    NextButton.Height := 38;
    NextButton.Margins.Left := 5;
    NextButton.Margins.Top := 5;
    NextButton.Margins.Right := 5;
    NextButton.Margins.Bottom := 5;
    NextButton.Caption := '>';
    NextButton.ChildOrder := 7;
    NextButton.ElementClassName := 'btn btn-info';
    NextButton.ElementFont := efCSS;
    NextButton.ElementPosition := epIgnore;
    NextButton.HeightStyle := ssAuto;
    NextButton.HeightPercent := 100.000000000000000000;
    NextButton.Visible := False;
    NextButton.WidthStyle := ssAuto;
    NextButton.WidthPercent := 100.000000000000000000;
    edFirstName.SetParentComponent(Self);
    edFirstName.Name := 'edFirstName';
    edFirstName.Left := 24;
    edFirstName.Top := 161;
    edFirstName.Width := 200;
    edFirstName.Height := 21;
    edFirstName.AutoCompletion := acNone;
    edFirstName.ChildOrder := 9;
    edFirstName.ElementClassName := 'form-control';
    edFirstName.ElementFont := efCSS;
    edFirstName.ElementPosition := epIgnore;
    edFirstName.HeightStyle := ssAuto;
    edFirstName.HeightPercent := 100.000000000000000000;
    edFirstName.TabOrder := 2;
    edFirstName.Text := 'edFirstName';
    edFirstName.WidthStyle := ssAuto;
    edFirstName.WidthPercent := 100.000000000000000000;
    SetEvent(edFirstName, Self, 'OnChange', 'edFirstNameExit');
    SetEvent(edFirstName, Self, 'OnExit', 'edFirstNameExit');
    edFirstName.DataField := 'FirstName';
    edFirstName.DataSource := EditDataSource;
    edLastName.SetParentComponent(Self);
    edLastName.Name := 'edLastName';
    edLastName.Left := 24;
    edLastName.Top := 188;
    edLastName.Width := 200;
    edLastName.Height := 21;
    edLastName.AutoCompletion := acNone;
    edLastName.ChildOrder := 10;
    edLastName.ElementClassName := 'form-control';
    edLastName.ElementFont := efCSS;
    edLastName.ElementPosition := epIgnore;
    edLastName.HeightStyle := ssAuto;
    edLastName.HeightPercent := 100.000000000000000000;
    edLastName.TabOrder := 3;
    edLastName.Text := 'edLastName';
    edLastName.WidthStyle := ssAuto;
    edLastName.WidthPercent := 100.000000000000000000;
    SetEvent(edLastName, Self, 'OnChange', 'edLastNameExit');
    SetEvent(edLastName, Self, 'OnExit', 'edLastNameExit');
    edLastName.DataField := 'LastName';
    edLastName.DataSource := EditDataSource;
    edAdd1.SetParentComponent(Self);
    edAdd1.Name := 'edAdd1';
    edAdd1.Left := 253;
    edAdd1.Top := 91;
    edAdd1.Width := 200;
    edAdd1.Height := 21;
    edAdd1.AutoCompletion := acNone;
    edAdd1.ChildOrder := 11;
    edAdd1.ElementClassName := 'form-control';
    edAdd1.ElementFont := efCSS;
    edAdd1.ElementPosition := epIgnore;
    edAdd1.HeightStyle := ssAuto;
    edAdd1.HeightPercent := 100.000000000000000000;
    edAdd1.TabOrder := 4;
    edAdd1.Text := 'edAdd1';
    edAdd1.WidthStyle := ssAuto;
    edAdd1.WidthPercent := 100.000000000000000000;
    SetEvent(edAdd1, Self, 'OnChange', 'edAdd1Exit');
    SetEvent(edAdd1, Self, 'OnExit', 'edAdd1Exit');
    edAdd1.DataField := 'Add1';
    edAdd1.DataSource := EditDataSource;
    edAdd2.SetParentComponent(Self);
    edAdd2.Name := 'edAdd2';
    edAdd2.Left := 253;
    edAdd2.Top := 118;
    edAdd2.Width := 200;
    edAdd2.Height := 21;
    edAdd2.AutoCompletion := acNone;
    edAdd2.ChildOrder := 12;
    edAdd2.ElementClassName := 'form-control';
    edAdd2.ElementFont := efCSS;
    edAdd2.ElementPosition := epIgnore;
    edAdd2.HeightStyle := ssAuto;
    edAdd2.HeightPercent := 100.000000000000000000;
    edAdd2.TabOrder := 5;
    edAdd2.Text := 'edAdd2';
    edAdd2.WidthStyle := ssAuto;
    edAdd2.WidthPercent := 100.000000000000000000;
    edAdd2.DataField := 'Add2';
    edAdd2.DataSource := EditDataSource;
    edAdd3.SetParentComponent(Self);
    edAdd3.Name := 'edAdd3';
    edAdd3.Left := 253;
    edAdd3.Top := 145;
    edAdd3.Width := 200;
    edAdd3.Height := 21;
    edAdd3.AutoCompletion := acNone;
    edAdd3.ChildOrder := 13;
    edAdd3.ElementClassName := 'form-control';
    edAdd3.ElementFont := efCSS;
    edAdd3.ElementPosition := epIgnore;
    edAdd3.HeightStyle := ssAuto;
    edAdd3.HeightPercent := 100.000000000000000000;
    edAdd3.TabOrder := 6;
    edAdd3.Text := 'edAdd3';
    edAdd3.WidthStyle := ssAuto;
    edAdd3.WidthPercent := 100.000000000000000000;
    edAdd3.DataField := 'Add3';
    edAdd3.DataSource := EditDataSource;
    edCity.SetParentComponent(Self);
    edCity.Name := 'edCity';
    edCity.Left := 253;
    edCity.Top := 171;
    edCity.Width := 200;
    edCity.Height := 21;
    edCity.AutoCompletion := acNone;
    edCity.ChildOrder := 14;
    edCity.ElementClassName := 'form-control';
    edCity.ElementFont := efCSS;
    edCity.ElementPosition := epIgnore;
    edCity.HeightStyle := ssAuto;
    edCity.HeightPercent := 100.000000000000000000;
    edCity.TabOrder := 7;
    edCity.Text := 'edCity';
    edCity.WidthStyle := ssAuto;
    edCity.WidthPercent := 100.000000000000000000;
    edCity.DataField := 'City';
    edCity.DataSource := EditDataSource;
    edPostCode.SetParentComponent(Self);
    edPostCode.Name := 'edPostCode';
    edPostCode.Left := 253;
    edPostCode.Top := 198;
    edPostCode.Width := 200;
    edPostCode.Height := 21;
    edPostCode.AutoCompletion := acNone;
    edPostCode.CharCase := wecUpperCase;
    edPostCode.ChildOrder := 15;
    edPostCode.ElementClassName := 'form-control';
    edPostCode.ElementFont := efCSS;
    edPostCode.ElementPosition := epIgnore;
    edPostCode.HeightStyle := ssAuto;
    edPostCode.HeightPercent := 100.000000000000000000;
    edPostCode.TabOrder := 8;
    edPostCode.Text := 'edPostCode';
    edPostCode.WidthStyle := ssAuto;
    edPostCode.WidthPercent := 100.000000000000000000;
    SetEvent(edPostCode, Self, 'OnChange', 'edPostCodeChange');
    edPostCode.DataField := 'PostCode';
    edPostCode.DataSource := EditDataSource;
    edEmail.SetParentComponent(Self);
    edEmail.Name := 'edEmail';
    edEmail.Left := 24;
    edEmail.Top := 217;
    edEmail.Width := 200;
    edEmail.Height := 21;
    edEmail.AutoCompletion := acNone;
    edEmail.CharCase := wecLowerCase;
    edEmail.ChildOrder := 16;
    edEmail.ElementClassName := 'form-control';
    edEmail.ElementFont := efCSS;
    edEmail.ElementPosition := epIgnore;
    edEmail.HeightStyle := ssAuto;
    edEmail.HeightPercent := 100.000000000000000000;
    edEmail.TabOrder := 11;
    edEmail.Text := 'edEmail';
    edEmail.WidthStyle := ssAuto;
    edEmail.WidthPercent := 100.000000000000000000;
    edEmail.DataField := 'Email';
    edEmail.DataSource := EditDataSource;
    edMobile.SetParentComponent(Self);
    edMobile.Name := 'edMobile';
    edMobile.Left := 24;
    edMobile.Top := 244;
    edMobile.Width := 200;
    edMobile.Height := 21;
    edMobile.AutoCompletion := acNone;
    edMobile.ChildOrder := 17;
    edMobile.ElementClassName := 'form-control';
    edMobile.ElementFont := efCSS;
    edMobile.ElementPosition := epIgnore;
    edMobile.HeightStyle := ssAuto;
    edMobile.HeightPercent := 100.000000000000000000;
    edMobile.TabOrder := 10;
    edMobile.Text := 'edMobile';
    edMobile.WidthStyle := ssAuto;
    edMobile.WidthPercent := 100.000000000000000000;
    edMobile.DataField := 'Mobile';
    edMobile.DataSource := EditDataSource;
    edTelephone.SetParentComponent(Self);
    edTelephone.Name := 'edTelephone';
    edTelephone.Left := 24;
    edTelephone.Top := 271;
    edTelephone.Width := 200;
    edTelephone.Height := 21;
    edTelephone.AutoCompletion := acNone;
    edTelephone.ChildOrder := 18;
    edTelephone.ElementClassName := 'form-control';
    edTelephone.ElementFont := efCSS;
    edTelephone.ElementPosition := epIgnore;
    edTelephone.HeightStyle := ssAuto;
    edTelephone.HeightPercent := 100.000000000000000000;
    edTelephone.TabOrder := 9;
    edTelephone.Text := 'edTelephone';
    edTelephone.WidthStyle := ssAuto;
    edTelephone.WidthPercent := 100.000000000000000000;
    edTelephone.DataField := 'Telephone';
    edTelephone.DataSource := EditDataSource;
    DateSigned.SetParentComponent(Self);
    DateSigned.Name := 'DateSigned';
    DateSigned.Left := 472;
    DateSigned.Top := 296;
    DateSigned.Width := 129;
    DateSigned.Height := 22;
    DateSigned.ElementClassName := 'form-control';
    DateSigned.HeightStyle := ssAuto;
    DateSigned.WidthStyle := ssAuto;
    DateSigned.BorderStyle := bsSingle;
    DateSigned.ChildOrder := 26;
    DateSigned.Color := clWhite;
    DateSigned.Date := 44461.755385451390000000;
    DateSigned.ElementFont := efCSS;
    DateSigned.ElementPosition := epIgnore;
    DateSigned.Role := '';
    DateSigned.TabOrder := 20;
    DateSigned.Text := '';
    SetEvent(DateSigned, Self, 'OnChange', 'DateSignedExit');
    SetEvent(DateSigned, Self, 'OnExit', 'DateSignedExit');
    DateSigned.DataField := 'DonationDate';
    DateSigned.DataSource := EditDataSource;
    ContactByPhone.SetParentComponent(Self);
    ContactByPhone.Name := 'ContactByPhone';
    ContactByPhone.Left := 318;
    ContactByPhone.Top := 340;
    ContactByPhone.Width := 113;
    ContactByPhone.Height := 22;
    ContactByPhone.ChildOrder := 27;
    ContactByPhone.ElementClassName := 'form-check-input';
    ContactByPhone.ElementFont := efCSS;
    ContactByPhone.ElementPosition := epIgnore;
    ContactByPhone.HeightStyle := ssAuto;
    ContactByPhone.HeightPercent := 100.000000000000000000;
    ContactByPhone.TabOrder := 14;
    ContactByPhone.WidthStyle := ssAuto;
    ContactByPhone.WidthPercent := 100.000000000000000000;
    SetEvent(ContactByPhone, Self, 'OnClick', 'ContactByClick');
    ContactByPhone.DataField := 'ContactByPhone';
    ContactByPhone.DataSource := EditDataSource;
    ContactByEmail.SetParentComponent(Self);
    ContactByEmail.Name := 'ContactByEmail';
    ContactByEmail.Left := 32;
    ContactByEmail.Top := 368;
    ContactByEmail.Width := 113;
    ContactByEmail.Height := 22;
    ContactByEmail.ChildOrder := 27;
    ContactByEmail.ElementClassName := 'form-check-input';
    ContactByEmail.ElementFont := efCSS;
    ContactByEmail.ElementPosition := epIgnore;
    ContactByEmail.HeightStyle := ssAuto;
    ContactByEmail.HeightPercent := 100.000000000000000000;
    ContactByEmail.TabOrder := 16;
    ContactByEmail.WidthStyle := ssAuto;
    ContactByEmail.WidthPercent := 100.000000000000000000;
    SetEvent(ContactByEmail, Self, 'OnClick', 'ContactByClick');
    ContactByEmail.DataField := 'ContactByEmail';
    ContactByEmail.DataSource := EditDataSource;
    ContactByText.SetParentComponent(Self);
    ContactByText.Name := 'ContactByText';
    ContactByText.Left := 183;
    ContactByText.Top := 368;
    ContactByText.Width := 113;
    ContactByText.Height := 22;
    ContactByText.ChildOrder := 27;
    ContactByText.ElementClassName := 'form-check-input';
    ContactByText.ElementFont := efCSS;
    ContactByText.ElementPosition := epIgnore;
    ContactByText.HeightStyle := ssAuto;
    ContactByText.HeightPercent := 100.000000000000000000;
    ContactByText.TabOrder := 19;
    ContactByText.WidthStyle := ssAuto;
    ContactByText.WidthPercent := 100.000000000000000000;
    SetEvent(ContactByText, Self, 'OnClick', 'ContactByClick');
    ContactByText.DataField := 'ContactByText';
    ContactByText.DataSource := EditDataSource;
    ContactByPost.SetParentComponent(Self);
    ContactByPost.Name := 'ContactByPost';
    ContactByPost.Left := 287;
    ContactByPost.Top := 368;
    ContactByPost.Width := 113;
    ContactByPost.Height := 22;
    ContactByPost.ChildOrder := 27;
    ContactByPost.ElementClassName := 'form-check-input';
    ContactByPost.ElementFont := efCSS;
    ContactByPost.ElementPosition := epIgnore;
    ContactByPost.HeightStyle := ssAuto;
    ContactByPost.HeightPercent := 100.000000000000000000;
    ContactByPost.TabOrder := 13;
    ContactByPost.WidthStyle := ssAuto;
    ContactByPost.WidthPercent := 100.000000000000000000;
    SetEvent(ContactByPost, Self, 'OnClick', 'ContactByClick');
    ContactByPost.DataField := 'ContactByPost';
    ContactByPost.DataSource := EditDataSource;
    TitleEdit.SetParentComponent(Self);
    TitleEdit.Name := 'TitleEdit';
    TitleEdit.Left := 24;
    TitleEdit.Top := 134;
    TitleEdit.Width := 200;
    TitleEdit.Height := 21;
    TitleEdit.AutoCompletion := acNone;
    TitleEdit.ChildOrder := 9;
    TitleEdit.ElementClassName := 'form-control';
    TitleEdit.ElementFont := efCSS;
    TitleEdit.ElementPosition := epIgnore;
    TitleEdit.HeightStyle := ssAuto;
    TitleEdit.HeightPercent := 100.000000000000000000;
    TitleEdit.TabOrder := 2;
    TitleEdit.Text := 'Title';
    TitleEdit.WidthStyle := ssAuto;
    TitleEdit.WidthPercent := 100.000000000000000000;
    TitleEdit.DataField := 'Title';
    TitleEdit.DataSource := EditDataSource;
    DataEditAmount.SetParentComponent(Self);
    DataEditAmount.Name := 'DataEditAmount';
    DataEditAmount.Left := 472;
    DataEditAmount.Top := 256;
    DataEditAmount.Width := 60;
    DataEditAmount.Height := 22;
    DataEditAmount.AutoCompletion := acNone;
    DataEditAmount.ChildOrder := 29;
    DataEditAmount.ElementClassName := 'form-control';
    DataEditAmount.ElementPosition := epIgnore;
    DataEditAmount.HeightStyle := ssAuto;
    DataEditAmount.HeightPercent := 100.000000000000000000;
    DataEditAmount.Text := 'DataEditAmount';
    DataEditAmount.WidthStyle := ssAuto;
    DataEditAmount.WidthPercent := 100.000000000000000000;
    SetEvent(DataEditAmount, Self, 'OnChange', 'DataEditAmountExit');
    SetEvent(DataEditAmount, Self, 'OnExit', 'DataEditAmountExit');
    SetEvent(DataEditAmount, Self, 'OnKeyPress', 'DataEditAmountKeyPress');
    DataEditAmount.DataField := 'Amount';
    DataEditAmount.DataSource := EditDataSource;
    CloseButton.SetParentComponent(Self);
    CloseButton.Name := 'CloseButton';
    CloseButton.Left := 346;
    CloseButton.Top := 404;
    CloseButton.Width := 144;
    CloseButton.Height := 38;
    CloseButton.Margins.Left := 5;
    CloseButton.Margins.Top := 5;
    CloseButton.Margins.Right := 5;
    CloseButton.Margins.Bottom := 5;
    CloseButton.Caption := 'Close';
    CloseButton.ChildOrder := 2;
    CloseButton.ElementClassName := 'btn btn-secondary';
    CloseButton.ElementFont := efCSS;
    CloseButton.ElementPosition := epIgnore;
    CloseButton.HeightStyle := ssAuto;
    CloseButton.HeightPercent := 100.000000000000000000;
    CloseButton.TabOrder := 21;
    CloseButton.WidthStyle := ssAuto;
    CloseButton.WidthPercent := 100.000000000000000000;
    SetEvent(CloseButton, Self, 'OnClick', 'CloseButtonClick');
    edCounty.SetParentComponent(Self);
    edCounty.Name := 'edCounty';
    edCounty.Left := 472;
    edCounty.Top := 198;
    edCounty.Width := 200;
    edCounty.Height := 21;
    edCounty.AutoCompletion := acNone;
    edCounty.ChildOrder := 15;
    edCounty.ElementClassName := 'form-control';
    edCounty.ElementFont := efCSS;
    edCounty.ElementPosition := epIgnore;
    edCounty.HeightStyle := ssAuto;
    edCounty.HeightPercent := 100.000000000000000000;
    edCounty.TabOrder := 8;
    edCounty.Text := 'edCounty';
    edCounty.WidthStyle := ssAuto;
    edCounty.WidthPercent := 100.000000000000000000;
    edCounty.DataField := 'County';
    edCounty.DataSource := EditDataSource;
    ExternalIdEdit.SetParentComponent(Self);
    ExternalIdEdit.Name := 'ExternalIdEdit';
    ExternalIdEdit.Left := 253;
    ExternalIdEdit.Top := 271;
    ExternalIdEdit.Width := 200;
    ExternalIdEdit.Height := 21;
    ExternalIdEdit.AutoCompletion := acNone;
    ExternalIdEdit.CharCase := wecUpperCase;
    ExternalIdEdit.ChildOrder := 15;
    ExternalIdEdit.ElementClassName := 'form-control';
    ExternalIdEdit.ElementFont := efCSS;
    ExternalIdEdit.ElementPosition := epIgnore;
    ExternalIdEdit.HeightStyle := ssAuto;
    ExternalIdEdit.HeightPercent := 100.000000000000000000;
    ExternalIdEdit.ReadOnly := True;
    ExternalIdEdit.TabOrder := 8;
    ExternalIdEdit.Text := 'ExternalIdEdit';
    ExternalIdEdit.WidthStyle := ssAuto;
    ExternalIdEdit.WidthPercent := 100.000000000000000000;
    MessageDialog.SetParentComponent(Self);
    MessageDialog.Name := 'MessageDialog';
    MessageDialog.Left := 488;
    MessageDialog.Top := 80;
    MessageDialog.Width := 24;
    MessageDialog.Height := 24;
    MessageDialog.HeightStyle := ssAuto;
    MessageDialog.WidthStyle := ssAuto;
    MessageDialog.Buttons := [];
    MessageDialog.Opacity := 0.200000000000000000;
    CountryList.SetParentComponent(Self);
    CountryList.Name := 'CountryList';
    CountryList.Left := 253;
    CountryList.Top := 225;
    CountryList.Width := 200;
    CountryList.Height := 33;
    CountryList.ElementClassName := 'form-select';
    CountryList.ElementPosition := epIgnore;
    CountryList.HeightStyle := ssAuto;
    CountryList.HeightPercent := 100.000000000000000000;
    CountryList.WidthStyle := ssAuto;
    CountryList.WidthPercent := 100.000000000000000000;
    SetEvent(CountryList, Self, 'OnChange', 'CountryListExit');
    CountryList.ItemIndex := -1;
    EditDataSource.SetParentComponent(Self);
    EditDataSource.Name := 'EditDataSource';
    SetEvent(EditDataSource, Self, 'OnDataChange', 'EditDataSourceDataChange');
    EditDataSource.Left := 160;
    EditDataSource.Top := 16;
    EditElements.SetParentComponent(Self);
    EditElements.Name := 'EditElements';
    EditElements.Actions.Clear;
    with EditElements.Actions.Add do
    begin
      Enabled := False;
      Event := heKeydown;
      ID := '';
      Name := 'EnterToTab';
      PreventDefault := False;
      Selector := 'input';
      StopPropagation := False;
    end;
    with EditElements.Actions.Add do
    begin
      Event := heBlur;
      ID := '';
      Name := 'ValidateData';
      PreventDefault := False;
      Selector := 'input,select';
      StopPropagation := False;
    end;
    EditElements.Left := 424;
    EditElements.Top := 24;
    CloseTimer.SetParentComponent(Self);
    CloseTimer.Name := 'CloseTimer';
    CloseTimer.Enabled := False;
    CloseTimer.Interval := 2000;
    CloseTimer.Left := 504;
    CloseTimer.Top := 40;
  finally
    FormCaption.AfterLoadDFMValues;
    MessageLabel.AfterLoadDFMValues;
    DonorIdLabel.AfterLoadDFMValues;
    ExternalIdLabel.AfterLoadDFMValues;
    ErrorMessagePostCode.AfterLoadDFMValues;
    ErrorMessageDateSigned.AfterLoadDFMValues;
    ErrorMessageAmount.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
    SaveButton.AfterLoadDFMValues;
    DataState.AfterLoadDFMValues;
    PriorButton.AfterLoadDFMValues;
    NextButton.AfterLoadDFMValues;
    edFirstName.AfterLoadDFMValues;
    edLastName.AfterLoadDFMValues;
    edAdd1.AfterLoadDFMValues;
    edAdd2.AfterLoadDFMValues;
    edAdd3.AfterLoadDFMValues;
    edCity.AfterLoadDFMValues;
    edPostCode.AfterLoadDFMValues;
    edEmail.AfterLoadDFMValues;
    edMobile.AfterLoadDFMValues;
    edTelephone.AfterLoadDFMValues;
    DateSigned.AfterLoadDFMValues;
    ContactByPhone.AfterLoadDFMValues;
    ContactByEmail.AfterLoadDFMValues;
    ContactByText.AfterLoadDFMValues;
    ContactByPost.AfterLoadDFMValues;
    TitleEdit.AfterLoadDFMValues;
    DataEditAmount.AfterLoadDFMValues;
    CloseButton.AfterLoadDFMValues;
    edCounty.AfterLoadDFMValues;
    ExternalIdEdit.AfterLoadDFMValues;
    MessageDialog.AfterLoadDFMValues;
    CountryList.AfterLoadDFMValues;
    EditDataSource.AfterLoadDFMValues;
    EditElements.AfterLoadDFMValues;
    CloseTimer.AfterLoadDFMValues;
  end;
end;

end.
